import { queryOptions } from '@tanstack/react-query';

import { findKimchiPremiumChart, findKimchiPremiumCurrent, findKimchiPremiumDaily, findKimchiPremiumMarkets } from '../api/fetcher';
import { KIMCHI_DAILY_EXCHANGE, KIMCHI_DAILY_TOP } from '../lib/daily-page';

import type { KimchiPremiumChartPeriod } from '../types';

export const kimchiPremiumQueryOptions = {
  getMarkets: (exchange: string = 'UPBIT') =>
    queryOptions({
      queryKey: ['kimchi-premium', 'markets', exchange],
      queryFn: () => findKimchiPremiumMarkets(exchange),
      staleTime: 1000 * 60 * 5,
    }),
  getCurrent: (exchange: string = 'UPBIT') =>
    queryOptions({
      queryKey: ['kimchi-premium', 'current', exchange],
      queryFn: () => findKimchiPremiumCurrent(exchange),
      staleTime: 1000 * 30,
      refetchInterval: 1000 * 30,
    }),
  getChart: (coinCode: string, exchange: string = 'UPBIT', period: KimchiPremiumChartPeriod = '24H') =>
    queryOptions({
      queryKey: ['kimchi-premium', 'chart', coinCode, exchange, period],
      queryFn: () => findKimchiPremiumChart(coinCode, exchange, period),
      staleTime: 1000 * 60 * 2,
      enabled: !!coinCode,
    }),
};

/**
 * TRAD-3709 P2 — 일간 페이지 쿼리. 키에 exchange·date·top 을 넣는다(top 은 상수 — 서버 캐시 키와 같은 축).
 * - 지난 날은 바뀌지 않는다 → staleTime 24h. 당일(partial)은 5분마다 재조회(김프 폴링 30초보다 느리게 — 요약 API 부담).
 * - retry 0: 404(KIMCHI_PREMIUM_004)가 정상 경로(데이터 없는 날)라 재시도가 의미 없다.
 * - 전일/익일 링크 활성 판정도 같은 옵션으로 이웃 날짜를 미리 당긴다(캐시 공유 → 이동 즉시 표시).
 */
export const kimchiPremiumDailyQueryOptions = {
  get: (date: string, isToday: boolean, exchange: string = KIMCHI_DAILY_EXCHANGE, top: number = KIMCHI_DAILY_TOP) =>
    queryOptions({
      queryKey: ['kimchi-premium', 'daily', exchange, date, top] as const,
      queryFn: () => findKimchiPremiumDaily(date, exchange, top),
      staleTime: isToday ? 5 * 60 * 1000 : 24 * 60 * 60 * 1000,
      retry: 0,
    }),
};
